<template>
  <div id="train_referee_outer" class="vue_body_min_height">
    <div v-if="currentBanner != null">
      <div>
        <img style="width: 100%;height: auto;" :src="currentBanner.url">
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "RefereePage",
  computed: {
    banners() {
      return this.$store.state.banners;
    },
    currentBanner() {
      if (this.banners == null) {
        return null;
      }
      let item = this.banners.find(function (item) {
        return  item.name == 'training';
      });

      if (item == undefined) {
        return null;
      }
      return item;
    },
  },
  methods: {
    listPageClicked() {
      this.$router.push({
        name: 'list',
      })
    },
    detailPageClicked() {
      this.$router.push({
        name: 'detail'
      })
    }

  }
}
</script>

<style scoped>
  #train_referee_outer {
    padding-bottom: 80px;
    text-align: center;
  }


</style>



// WEBPACK FOOTER //
// src/pages/RefereePage.vue